import React from "react";
import type { ShippingOption, ShippingOptionType } from "@tempefab-model/tempe-fabrication-client";

interface ShippingOptionsSelectorProps {
  shippingOptions: ShippingOption[];
  selectedOption: ShippingOptionType | null;
  onSelect: (option: ShippingOptionType) => void;
  error?: string;
}

const ShippingOptionsSelector: React.FC<ShippingOptionsSelectorProps> = ({
  shippingOptions,
  selectedOption,
  onSelect,
  error,
}) => {
  return (
    <div
      style={{
        backgroundColor: "#f9f9f9",
        padding: "30px",
        borderRadius: "8px",
        marginBottom: "20px",
      }}
    >
      <h3 style={{ marginBottom: "20px", fontSize: "20px" }}>Shipping Method</h3>

      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        {shippingOptions.map((option) => {
          const isSelected = selectedOption === option.type;
          return (
            <div
              key={option.type}
              onClick={() => option.type && onSelect(option.type)}
              style={{
                border: isSelected ? "2px solid var(--color-orange1)" : "2px solid #ddd",
                borderRadius: "8px",
                padding: "20px",
                cursor: "pointer",
                backgroundColor: isSelected ? "#fff5eb" : "white",
                transition: "all 0.2s ease",
                position: "relative",
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = "#bbb";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = "#ddd";
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                {/* Radio button */}
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    border: isSelected ? "6px solid var(--color-orange1)" : "2px solid #ddd",
                    flexShrink: 0,
                  }}
                />

                {/* Option details */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <div style={{ fontWeight: "600", fontSize: "16px", marginBottom: "5px" }}>
                        {option.type?.replace(/_/g, " ")}
                      </div>
                      <div style={{ fontSize: "14px", color: "#666" }}>
                        {option.deliveryPromise}
                      </div>
                    </div>
                    <div style={{ fontWeight: "600", fontSize: "18px" }}>
                      ${option.cost?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {error && (
        <div style={{ color: "#dc3545", fontSize: "14px", marginTop: "10px" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default ShippingOptionsSelector;
